import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Flags } from '../../../types/flags.type';

@Component({
  selector: 'app-mu-modal-form-sms',
  templateUrl: './mu-modal-form-sms.component.html',
  styleUrls: ['./mu-modal-form-sms.component.sass'],
})
export class MuModalFormSmsComponent<FlagType> implements OnInit {
  /**
   * dialog id
   */
  @Input() id = 'mu-modal-dialog-sms';
  /**
   * icon of the dialog
   */
  @Input() icon: string;

  /**
   * Dialog title
   */
  @Input() title: string;

  /**
   * indicate if show or not the dialog
   */
  @Input() showModal: boolean;
  /**
   * show modal flag
   */
  @Input() showFlag: FlagType;
  /**
   * show modal flag
   */
  @Input() showCloseIcon = false;
  /**
   * action modal flag
   */
  @Input() actionFlag: FlagType;
  /**
   * show loader flag
   */
  @Input() loaderFlag: FlagType;
  /**
   * flag list
   */
  @Input() flagList: Flags<FlagType>;
  /**
   * font size 14px for buttons
   */
  @Input() buttonSlim: boolean;
  /**
   * show button cancel
   */
  @Input() buttonCancel: boolean;
  /**
   * custom label for button cancel
   */
  @Input() buttonCancelLabel: string;
  /**
   * custom redirect link to cancel button
   */
  @Input() buttonCancelLink: string;
  /**
   * show main button to fire action
   */
  @Input() buttonMainAction: boolean;
  /**
   * custom label for button action
   */
  @Input() buttonMainActionLabel: string;
  /**
   * subTitle
   */
  @Input() subTitle: string;
  /**
   * subTitle value
   */
  @Input() numberPhone: string;
  /**
   * form data to disable main action
   */
  @Input() formData: UntypedFormGroup;
  /**
   * event cancel action
   */
  @Output() eventCancelAction = new EventEmitter();
  /**
   * event main action
   */
  @Output() eventMainAction = new EventEmitter();
  /**
   * event fired when the modal is closed
   */
  @Output() eventCloseDialogModal = new EventEmitter();

  constructor(private router: Router) {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * fire the event when the modal is closed
   */
  _eventCloseDialogModal(): void {
    if (this.eventCloseDialogModal) {
      this.eventCloseDialogModal.emit();
      return environment.guardClause;
    }
    if (this.flagList.get(this.showFlag)) {
      this.flagList.disable(this.showFlag);
    }
  }

  /**
   * cancel basic action
   */
  _eventCancelAction(): void {
    if (this.buttonCancelLink) {
      this.router.navigate([this.buttonCancelLink]);
      return environment.guardClause;
    }
    this.flagList.disable(this.showFlag);
    this.eventCancelAction.emit();
  }

  /**
   * main basic action
   */
  _eventMainAction(): void {
    if (this.formData && this.formData.get('isInvalidForm').value) {
      return environment.guardClause;
    }
    this.flagList.enable(this.actionFlag);
    this.eventMainAction.emit();
  }

  /**
   * get modal state to show modal
   */
  get showModalState(): boolean {
    return this.flagList ? this.flagList.get(this.showFlag) : this.showModal;
  }

  set showModalState(value: boolean) {
    if (this.showCloseIcon) {
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      value ? this.flagList.enable(this.showFlag) : this.flagList.disable(this.showFlag);
      this.showModal = value;
    }
  }
}
